import React from "react";

export function WQueenIcon({ color = "#3C3C3C" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 133 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.3332 4.2529C63.0093 4.2529 59.8215 5.43077 57.4711 7.5274C55.1207 9.62403 53.8003 12.4677 53.8003 15.4327C53.7997 16.9012 54.1235 18.3554 54.7531 19.7122C55.3827 21.0691 56.3058 22.302 57.4696 23.3405C58.6334 24.3791 60.0152 25.2029 61.5361 25.765C63.0569 26.3271 64.687 26.6164 66.3332 26.6164C67.9794 26.6164 69.6095 26.3271 71.1303 25.765C72.6512 25.2029 74.033 24.3791 75.1968 23.3405C76.3607 22.302 77.2837 21.0691 77.9133 19.7122C78.5429 18.3554 78.8667 16.9012 78.8661 15.4327C78.8661 12.4677 77.5457 9.62403 75.1953 7.5274C72.8449 5.43077 69.6571 4.2529 66.3332 4.2529Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.3332 26.6164C41.7398 26.6164 30.0687 48.8551 30.0687 65.7647H102.874C102.874 48.8551 90.9304 26.6164 66.3332 26.6164Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.4882 42.5433C59.0388 42.5433 57.6139 52.559 50.8523 53.3527C43.9736 54.1578 38.0737 44.6145 31.0098 46.7877C25.3594 48.5263 28.0693 56.6145 24.1877 58.7877C18.8888 61.7546 12.1499 51.8636 4.19403 57.6614C30.0384 91.0309 34.7515 104.441 34.366 128.788H98.6104C98.2211 104.437 102.934 91.0309 128.782 57.6576C120.823 51.8636 114.084 61.7546 108.789 58.7915C104.907 56.6145 107.613 48.5263 101.963 46.7877C94.9027 44.6145 89.0029 54.1578 82.1203 53.349C75.3588 52.5553 73.9339 42.5395 66.4844 42.5395L66.4882 42.5433Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.4882 122.79C66.4882 122.79 31.9811 122.972 22.3017 128.913C15.7745 132.919 14.2324 142.708 15.1206 152.811H117.856C118.744 142.712 117.206 132.916 110.675 128.909C100.999 122.972 66.492 122.786 66.492 122.786L66.4882 122.79Z"
        fill="#F0F0F0"
        stroke={color}
        stroke-width="8"
        stroke-linejoin="round"
      />
    </svg>
  );
}
